import React, { useEffect } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { compose } from 'redux';
import SpeechTest from './speechTest';
import PracticeTest from './practiceTest';
import Loader from '../../utils/Loader';
import Config from '../../config/Config';
import {
	getChildCourse,
	getChildDetails,
	getChildToken,
} from '../../redux/parentDashboard/parentDashboard.actions';
import { changeActiveCourse } from '../../redux/changeCourse/changeCourse.actions';
import FinalTest from './finalTest';
import TestInstruction from '../common/testInstruction';
import PermitMicModal from '../common/permitMic';
import ReviewAttemptModal from '../common/reviewAttemptModal';
import EchoTest from '../common/EchoTest';
import ListAnimation from '../utils/animations/list';
import { kid_img, _months } from '../../utils/const';

const kid_img_num = Math.floor(Math.random() * 4) + 0;
const _todayDate = new Date();
const UpnextList = ({
	getChildCourse,
	match,
	courses,
	history,
	childrenList,
	changeActiveCourse,
	user_id,
	activeCourseId,
	getChildDetails,
}) => {
	const { course_id, child_id, child_name } = childrenList[0] || [];

	useEffect(() => {
		getChildDetails();
	}, [getChildDetails]);

	useEffect(() => {
		if (!!child_id || !!user_id) {
			getChildToken({ child_id: child_id || user_id, id: 0 });
		}
	}, [child_id, user_id]);

	useEffect(() => {
		Loader.hide();
		if (!!course_id) {
			getChildCourse(course_id);
			changeActiveCourse(course_id);
		}
	}, [course_id, getChildCourse, changeActiveCourse, childrenList]);

	return (
		<div className="course-division1 container" style={{ margin: '0 auto' }}>
			<div className="kid-greeting">
				<h4 className="parentGreeting">Hello {child_name}!</h4>
				<span> Today is a great day to learn!</span>
				<img
					src={`${Config.ASSETSPATH}img/${kid_img[kid_img_num]}`}
					alt="Hello {child_name}"
				/>
			</div>
			<div className="display-flex justify-between" style={{ margin: '2%' }}>
				<strong>{`${
					_months[_todayDate.getMonth()]
				} ${_todayDate.getDate()}, ${_todayDate.getFullYear()}`}</strong>
			</div>
			<ListAnimation open={true}>
				{/* Practice and Final test */}
				{!!courses?.units &&
					courses.units[1]?.course_elements?.map((element) => {
						const { element_type, elementID } = element;
						return element_type === 'W' ? (
							<PracticeTest key={elementID} {...element} />
						) : (
							<FinalTest key={elementID} {...element} />
						);
					})}

				<SpeechTest />
				{/* English Test */}
				{/* <div className="dash-courses last-dash-course">
					<div className="dash-course-logo">
						<img
							src="https://storage.googleapis.com/assets.thehindustep.in/img/STEP_logo.png"
							alt="courseimage"
						/>
					</div>
					<div className="dash-course-decs">
						<div className="d-flex flex-row align-items-center justify-content-between">
							<div className="flex-grow-1">
								<p>Kids Courses</p>
								<p className="dash-decs-date">
									<strong>You haven't bought any kids courses.</strong>
								</p>
							</div>
							<div>
								<button
									onClick={() => history.push(`/buycourse?childId=${child_id}`)}
									aria-label="Purchase Course"
									className="btn btn-primary step-btn"
								>
									View Courses
								</button>
							</div>
						</div>
					</div>
				</div> */}
			</ListAnimation>
			<TestInstruction hideSpeakTest={true} />
			<EchoTest />
			<ReviewAttemptModal />
			<PermitMicModal />
		</div>
	);
};

const mapStateToProps = (state) => {
	const {
		courses,
		childrenList,
		child_id,
		course_id,
		child_name,
		activeCourseId,
	} = state.rootReducer.parentDetails;
	const { user_id } = state.rootReducer.userDetails;
	return {
		courses,
		childrenList,
		child_id,
		course_id,
		child_name,
		activeCourseId,
		user_id,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		getChildCourse: (val) => dispatch(getChildCourse(val)),
		changeActiveCourse: (id) => dispatch(changeActiveCourse(id)),
		getChildDetails: () => dispatch(getChildDetails()),
		getChildToken: (val) => dispatch(getChildToken(val)),
	};
};

export default withRouter(
	compose(connect(mapStateToProps, mapDispatchToProps))(UpnextList),
);
